import * as React from "react";
import Divider from "@mui/material/Divider";
import {Link, Navigate} from "react-router-dom";
import List from "@mui/material/List";
import {usePath} from "./PathContext";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import QuizIcon from "@mui/icons-material/Quiz";
import {Button} from "@mui/material";
import "./menulist.css";
import {styled} from "@mui/material/styles";
// import { usePathname } from 'next/navigation';
import {useNavigate} from "react-router-dom";
import json2mq from "json2mq";

import {useLocation} from "react-router-dom";
import {useState, useEffect} from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import Draggable from "react-draggable";
import "./side_bar_menu.css";
import LoginPopUp from "../common/alert/login/LoginPopUp";
import {useDisconnect} from "wagmi";
import {useAppKitAccount} from "@reown/appkit/react";
// const ASSET_PATH = process.env.PUBLIC_URL;
// import path from "path";
function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

function SideBarMenu({setLoginModalOpen}) {
    const navigate = useNavigate();
    const location = useLocation();
    const {address, isConnected} = useAppKitAccount();
    const {disconnectAsync} = useDisconnect();
    const {currentPath, setCurrentPath} = usePath();

    useEffect(() => {
        // Set the current path when the component mounts
        setCurrentPath(window.location.pathname);
    }, [setCurrentPath]);

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = async() => {
        localStorage.removeItem("cw_portfolio_user");
        console.log("isConnected", isConnected);
        if (isConnected) {
            try {
                const resp = await disconnectAsync();
                console.log("Wallet disconnected",resp);
            } catch (err) {
                console.error("Failed to disconnect wallet:", err);
            }
        }
        // setSnackbaropen(true);
        navigate(location.pathname, {replace: true});
        setOpen(false);
    };

    

    const handleLoginClick = () => {
        const originalUrl = location.pathname;
        sessionStorage.setItem("originalUrl", originalUrl);
        window.history.pushState({}, "", "/login");
        localStorage.setItem("isPopupManuallyOpened", "true");
        setLoginModalOpen(true);
    };

   

    const handleCloseCancle = async () => {
        

        setOpen(false);
    };
    const [snackbaropen, setSnackbaropen] = React.useState(false);
    const [isHover, setIsHover] = useState(false);
    const StyledList = styled(List)({
        "&& .Mui-selected, && .Mui-selected:hover": {
            background: "linear-gradient(90deg, #1877F2 0%, #519DFF 100%)",
            color: "white",
            fontWeight: "bold !important",
            "&, & .MuiListItemIcon-root": {
                color: "white",
                fontWeight: "bold",
                borderRadius: "10px",
            },
        },
        "& .MuiListItemButton-root:hover": {
            background: "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
            fontWeight: "700 !important",
            color: "black !important",
            "&, & .MuiListItemIcon-root": {
                color: "white",
                fontWeight: "bold",
                borderRadius: "10px",
            },
        },
    });

    const handleMouseEnter = () => {
        setIsHover(true);
    };
    const closesnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackbaropen(false);
    };
    const handleMouseLeave = () => {
        setIsHover(false);
    };
    const mediaQueryVar2 = useMediaQuery(
        json2mq({
            maxHeight: 700,
        })
    );

    const pathName = useLocation().pathname;
    const isActive = (route) => {
        return pathName === `/${route}`;
    };

    const hangleLogOutClick = (path) => {
        // router.push(`/${path}`);

        // setOpen(true);
        localStorage.removeItem("cw_portfolio_user");
        // setSnackbaropen(true);
        navigate(`/${path}`, {replace: true});
    };

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const menuItems = [
        {
            name: userData ? "My Portfolios" : "Portfolio Audit",
            icon: `${window.constants.asset_path}/images/portfolio_tab.svg`,
            hoverIcon: `${window.constants.asset_path}/images/portfolio_tab.svg`,
            activeIcon: `${window.constants.asset_path}/images/portfolio_tab.svg`,
            route: userData ? "my-portfolio/detailed-portfolio-analysis" : "audit-my-portfolio",
            
        },
        {
            name: "Crypto Screener",
            icon: `${window.constants.asset_path}/images/sidemenu_icons/search-icon.svg`,
            hoverIcon: `${window.constants.asset_path}/images/search_tab.svg`,
            activeIcon: `${window.constants.asset_path}/images/search-icon.svg`,
            route: "crypto-screener",
            bagde: "Most  Popular",
            
        },
        
        {
            name: "All Crypto Predictions",

            icon: `${window.constants.asset_path}/images/sidemenu_icons/crypto_prediction_tab.svg`,
            hoverIcon: `${window.constants.asset_path}/images/sidemenu_icons/crypto_prediction_tab.svg`,

            activeIcon: `${window.constants.asset_path}/images/sidemenu_icons/crypto_prediction_tab.svg`,
            route: "crypto-predictions",
            bagde: "Popular",
            // marginTop: "30px",
        },
        {
            name: "Best Crypto Predictions",

            icon: `${window.constants.asset_path}/images/red-arrow-point.svg`,
            hoverIcon: `${window.constants.asset_path}/images/red-arrow-point.svg`,

            activeIcon: `${window.constants.asset_path}/images/red-arrow-point.svg`,
            route: "crypto-predictions/best-predictions",
            bagde: "Premium",
        },
         {
            name: "All Crypto Portfolios",

            icon: `${window.constants.asset_path}/images/sidemenu_icons/crypto_portfolio.svg`,
            hoverIcon: `${window.constants.asset_path}/images/sidemenu_icons/crypto_portfolio.svg`,

            activeIcon: `${window.constants.asset_path}/images/sidemenu_icons/crypto_portfolio.svg`,
            route: "portfolio-gallery",
        },

        {
            name: "Best Crypto Portfolios",

            icon: `${window.constants.asset_path}/images/sidemenu_icons/top_portfolio_tab.svg`,
            hoverIcon: `${window.constants.asset_path}/images/sidemenu_icons/top_portfolio_tab.svg`,

            activeIcon: `${window.constants.asset_path}/images/sidemenu_icons/top_portfolio_tab.svg`,
            route: "top-portfolios",
            bagde: "Premium",
            // marginTop: "30px",
        },
        {
            name: "Indices",

            icon: `${window.constants.asset_path}/images/sidemenu_icons/indices_tab.svg`,
            hoverIcon: `${window.constants.asset_path}/images/sidemenu_icons/indices_tab.svg`,
            activeIcon: `${window.constants.asset_path}/images/sidemenu_icons/indices_tab.svg`,
            route: "indices",
            bagde: "Popular",
        },
        // {
        //     name: "Alerts",

        //     icon: `${window.constants.asset_path}/images/premium_tag.svg`,
        //     hoverIcon: `${window.constants.asset_path}/images/premium_tag.svg`,

        //     activeIcon: `${window.constants.asset_path}/images/premium_tag.svg`,
        //     route: "alerts",
        //     bagde: "Premium",
        // },
       
        {
            name: "Alerts",

            icon: `${window.constants.asset_path}/images/premium_tag.svg`,
            hoverIcon: `${window.constants.asset_path}/images/premium_tag.svg`,

            activeIcon: `${window.constants.asset_path}/images/premium_tag.svg`,
            route: "alerts",
            bagde: "Premium",
        },
        {
            name: "Crypto Influencer Rankings",

            icon: `${window.constants.asset_path}/images/sidemenu_icons/influencer_ranking_tab.svg`,
            hoverIcon: `${window.constants.asset_path}/images/sidemenu_icons/influencer_ranking_tab.svg`,

            activeIcon: `${window.constants.asset_path}/images/sidemenu_icons/influencer_ranking_tab.svg`,
            route: "crypto-influencer-rankings",
            // marginTop: "30px",
        },
    ];

    const menuItems2 = [
        {
            name: "Privacy Policy",
            route: "privacyPolicy",
        },
        {
            name: "Contact Us",
            route: "contactus",
        },
        {
            name: "FAQs",
            route: "portfoliofaqs",
        },

        // {
        //     name: "Terms of Use",
        //     icon: `${window.constants.asset_path}/images/icons/term-condition.svg`,
        //     hoverIcon: `${window.constants.asset_path}/images/icons/term-condition.svg`,
        //     activeIcon: `${window.constants.asset_path}/images/icons/term-condition.svg`,
        //     route: "termofuse",
        // },
        // {
        //     name: userData ? "Log Out" : "Login/Signup",
        //     icon: `${window.constants.asset_path}/images/sidemenu_icons/login_icon.svg`,
        //     hoverIcon: `${window.constants.asset_path}/images/sidemenu_icons/login_icon.svg`,
        //     activeIcon: `${window.constants.asset_path}/images/sidemenu_icons/login_icon.svg`,
        //     route: "termofuse",
        // },
    ];

    return (
        <div className="mai_div_menu" style={{backgroundColor: "white"}}>
            {/* {isLoginModalOpen && (
                <LoginPopUp
                    isLoginModalOpen={isLoginModalOpen}
                    setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                    onClose={handleModalClose}
                />
            )} */}
            <div
                style={{
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center", // vertically center items
                    gap: "20px", // space between logo and link
                    padding: "10px 5px",
                }}
            >
                <a href="/">
                    <img
                        alt="Logo"
                        src={window.constants.asset_path + "/images/logo_with_bg.png"}
                        style={{width: "130px", height: "auto"}}
                    />
                </a>

                <a
                    href="/subscriptions"
                    style={{
                        fontFamily: "Satoshi, sans-serif",
                        fontWeight: "600",
                        fontSize: "12px",
                        textDecoration: "none",
                        color: "#1877F2",
                        border: "1.8px solid rgba(24, 119, 242, 1)",
                        background:
                            "linear-gradient(91.4deg, rgba(154, 255, 249, 0.6) 18.86%, rgba(255, 240, 109, 0.6) 100.02%)",
                        borderRadius: "16px",
                        padding: "6px 2px ",
                    }}
                >
                    Go To Screener360
                </a>
            </div>

            <div
                style={{display: "flex", flexDirection: "column", marginTop: "0px", height: "94vh"}}
                className="sidebarMenu"
            >
                <div style={{flexGrow: mediaQueryVar ? 1 : 0}}>
                    <StyledList>
                        <List
                            component="nav"
                            aria-label="secondary mailbox folder"
                            className="sideMenuList scrollable-list sideBarTopMenu"
                        >
                            {menuItems.map(({name, icon, bagde, hoverIcon, activeIcon, route, marginTop}) => {
                                const active = isActive(route);

                                return (
                                    <ListItem
                                        disablePadding
                                        key={route}
                                        style={{
                                            // paddingLeft: "26px",
                                            fontSize: "16px",
                                            fontFamily: "Satoshi, sans-serif",
                                            lineHeight: "24px",
                                            fontWeight: "500",
                                            color: "black",
                                            backgroundColor: "white",
                                            marginTop: marginTop? marginTop : "3px",
                                            padding: mediaQueryVar ? "0px 5px" : "0px 10px",
                                        }}
                                        component={Link}
                                        to={`/${route}`}
                                    >
                                        <ListItemButton
                                            className={active ? "activeMenu" : ""}
                                            style={{
                                                borderRadius: "2rem",
                                                paddingTop: name === "Most Accurate Crypto Predictions" ? "2px" : "6px",
                                                paddingBottom:
                                                    name === "Most Accurate Crypto Predictions" ? "2px" : "6px",
                                                paddingLeft: "18px",
                                                paddingRight: "0px",
                                                marginBottom: "10px",
                                                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                                border: "1px solid rgba(24, 119, 242, 1)",
                                                borderBottom: "5px solid #1877F2",
                                                fontSize: "15px",
                                                fontWeight: active ? "700" : "500",
                                                fontFamily: "Satoshi, sans-serif",
                                                position: "relative",
                                                overflow: "visible",
                                                height: "45px",
                                                lineHeight: "20px",
                                            }}
                                        >
                                            {/* ICON + NAME */}
                                            <div style={{display: "flex", alignItems: "center"}}>
                                                <img
                                                    className="frameIcon"
                                                    alt=""
                                                    src={icon}
                                                    style={{marginRight: "8px"}}
                                                />
                                                <span
                                                    style={{
                                                        letterSpacing: "0.7px",
                                                        wordBreak: "break-word",
                                                        whiteSpace: "normal",
                                                        display: "inline-block",
                                                        maxWidth: "100%",
                                                        padding: "0px 0px",
                                                        fontSize: "14px",
                                                        marginLeft:
                                                            name === "Most Accurate Crypto Predictions" ? "-35px" : "",
                                                    }}
                                                >
                                                    {name}
                                                </span>
                                            </div>

                                            {/* BADGE */}
                                            {bagde && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "-5px", // move up a little
                                                        right: "0px", // move right outside
                                                        background: "#1877F2",
                                                        color: "white",
                                                        borderRadius: "9999px",
                                                        padding: "3px 6px",
                                                        fontSize: "10px",
                                                        fontWeight: "bold",
                                                        minWidth: "18px",
                                                        height: "18px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    {bagde} {/* replace this with your dynamic badge value */}
                                                </div>
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </StyledList>
                </div>
                <div className="horizonatal-rule">
                    <hr></hr>
                </div>
                {/* Pushes the bottom list to the bottom */}
                <div className="sideMenuBottomList">
                    <StyledList>
                        <List
                            sx={{
                                margin: 0,
                                padding: 0, // Removes default padding
                                "& .MuiListItem-root": {
                                    padding: "0px 8px", // Less vertical padding
                                    minHeight: "32px", // Reduce item height
                                },
                            }}
                            component="nav"
                            aria-label="secondary mailbox folder"
                            className="sideMenuList"
                            style={{
                                display: "flex",
                                flexWrap: "wrap", // Allow items to go to next line
                                justifyContent: "space-between", // Space between 2 items
                            }}
                        >
                            {menuItems2.map(({name, icon, hoverIcon, activeIcon, route}) => {
                                const active = isActive(route);

                                const handleMenuClick = (route) => {
                                    navigate(`/${route}`);
                                };

                                return (
                                    <ListItem
                                        disablePadding
                                        key={route}
                                        style={{
                                            width: "48%", // Important: Half of row minus little gap
                                            // padding: "0px 10px",
                                            fontSize: "20px",
                                            fontWeight: active ? "700" : "700",
                                            fontFamily: "Satoshi, sans-serif",
                                            lineHeight: "24px",
                                            fontWeight: "500",
                                            color: "rgba(127, 127, 128, 1)",
                                            backgroundColor: "white",
                                        }}
                                        component="div"
                                        onClick={() => handleMenuClick(route)}
                                    >
                                        <ListItemButton
                                            className={active ? "activeMenu" : ""}
                                            style={{
                                                borderRadius: "10px",
                                                paddingLeft: "18px",
                                                paddingRight: "0px",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: "13px",
                                                    fontWeight: "700",
                                                    fontFamily: "Satoshi, sans-serif",
                                                    letterSpacing: "0.7px",
                                                }}
                                            >
                                                {name}
                                            </span>
                                            {icon && (
                                                <img
                                                    className="frameIcon"
                                                    alt=""
                                                    src={active ? activeIcon : icon}
                                                    style={{
                                                        marginRight: "-10px",
                                                        right: 0,
                                                        width: "27px",
                                                        height: "27px",
                                                    }}
                                                />
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                            <ListItem
                                disablePadding
                                style={{
                                    width: "48%", // Important: Half of row minus little gap
                                    // padding: "0px 10px",
                                    fontSize: "20px",
                                    fontWeight: "700",
                                    fontFamily: "Satoshi, sans-serif",
                                    lineHeight: "24px",
                                    fontWeight: "500",
                                    color: "rgba(127, 127, 128, 1)",
                                    backgroundColor: "white",
                                }}
                                component="div"
                                onClick={() => (userData ? handleClickOpen() : handleLoginClick())}
                            >
                                <ListItemButton
                                    className={""}
                                    style={{
                                        borderRadius: "10px",
                                        paddingLeft: userData ? "18px" : "2px",
                                        paddingRight: "0px",
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: "13px",
                                            fontWeight: "700",
                                            color: "black",
                                            fontFamily: "Satoshi, sans-serif",
                                            letterSpacing: "0.7px",
                                        }}
                                    >
                                        {userData ? "Log Out" : "Login/Signup"}
                                    </span>

                                    <img
                                        className="frameIcon"
                                        alt=""
                                        src="/images/sidemenu_icons/login_icon.svg"
                                        style={{marginRight: "-10px", right: 0, width: "27px", height: "27px"}}
                                    />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </StyledList>
                </div>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{cursor: "move"}} id="draggable-dialog-title">
                    Logout
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>Are you sure to logout?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleCloseCancle}>
                        Cancel
                    </Button>
                    <Button onClick={handleClose}>Logout</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default SideBarMenu;
